import React from "react";

type IconProps = {
  svgIcon?: React.ReactNode;
  iconName?: string;
} & React.HTMLAttributes<HTMLSpanElement>;

export const Icon = ({ svgIcon, iconName, className, ...rest }: IconProps) => {
  if (svgIcon) {
    return React.isValidElement(svgIcon)
      ? React.cloneElement(svgIcon, {
          ...(svgIcon.props as Record<string, unknown>),
          ...(className ? { className: [svgIcon.props.className, className].filter(Boolean).join(" ") } : {}),
          ...rest,
        })
      : svgIcon;
  }

  const mergedClassName = ["material-symbols-outlined", className].filter(Boolean).join(" ");

  return (
    <span className={mergedClassName} {...rest}>
      {iconName}
    </span>
  );
};
